import {HStack, Icon, Text, VStack} from "@chakra-ui/react";
import {RiDraggable} from "react-icons/ri";
import dayjs from "dayjs";
import {HiOutlineChevronRight} from "react-icons/hi2";
import { BsLightningCharge } from "react-icons/bs";
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';


const IntentListItem = ({intent, onClick}) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: intent.id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    };

    const handleClick = () => {
        onClick && onClick();
    }

    return (
        <HStack ref={setNodeRef} style={style} {...attributes} onClick={handleClick} p={6} borderWidth={1} borderColor={'border.secondary'} w={'full'} borderRadius={12} _hover={{bg: 'bg.highlight'}}
                transition="background 0.2s ease-in-out"
                bg={'bg.card'} columnGap={6} cursor={'pointer'}>
            <Icon fontSize={32} color={'white'} {...listeners} cursor="grab">
                <RiDraggable />
            </Icon>
            <HStack w={'full'} align={'flex-start'} columnGap={12}>
                <VStack alignItems={'flex-start'} gap={0} flex={2} justifyContent={"flex-start"} w={'26em'}>
                    <Text color={'white'}>{intent?.name}</Text>
                    {intent?.displayName && <Text color={'text.grey'} fontSize={12}>{intent.displayName}</Text>}
                    <Text color={'text.grey'}
                          w={'100%'}
                          whiteSpace="nowrap"
                          noOfLines={1}
                          overflow="hidden"
                          textOverflow="ellipsis">
                        Examples: {intent.trainingPhrases?.join(", ")}
                    </Text>
                    <Text color={'text.grey'}
                          w={'100%'}
                          whiteSpace="nowrap"
                          noOfLines={1}
                          overflow="hidden"
                          textOverflow="ellipsis">
                        Responses: {[intent.finalResponse].join(", ")}
                    </Text>
                </VStack>
                <VStack alignItems={'flex-start'} gap={0} flex={3}>
                    <Text color={'white'}>{'Entities'}</Text>
                    {intent.entities.map(item => {
                        return (
                            <HStack>
                                <Icon fontSize={14} color={'text.grey'}>
                                    <BsLightningCharge />
                                </Icon>
                                <Text color={'text.grey'}>{item.completeResponse}</Text>
                            </HStack>
                        )
                    })}
                </VStack>
            </HStack>
            <Icon fontSize={28} strokeWidth={1.5} color={'white'}>
                <HiOutlineChevronRight/>
            </Icon>
        </HStack>
    )
}

export default IntentListItem;